import Textarea from 'components/Input/components/Textarea';
import { useTranslation } from 'react-i18next';

interface CustomReasonInputProps {
  value: string;
  errorMessage?: string;
  onChange: (value: string) => void;
}

export const CustomReasonInput = ({
  value,
  errorMessage,
  onChange,
}: CustomReasonInputProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Textarea
      value={value}
      helperText={errorMessage}
      error={!!errorMessage}
      maxLength={250}
      placeholder={t('RETURN_CUSTOM_REASON_PLACEHOLDER')}
      onChange={(e) => onChange(e.currentTarget.value)}
    />
  );
};
